import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

const ScrollToCorrectPageLocation = () => {
  const {hash, pathname} = useLocation()

  useEffect(() => {
    const handleLoad = () => {
      if (hash) {
        const element = document.getElementById(hash.replace('#', ''))

        if (element) {
          element.scrollIntoView({behavior: 'smooth', block: 'start'})

          setTimeout(() => {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY
            window.scrollTo({
              top: elementPosition - 80,
              behavior: 'smooth'
            })
          }, 100)
        }
      } else {
        const header = document.querySelector('#header')
        header.classList.remove('hidden')
        window.scrollTo(0, 0)
      }
    }

    if (document.readyState === 'complete') {
      handleLoad()
    } else {
      window.addEventListener('load', handleLoad)
    }

    return () => {
      window.removeEventListener('load', handleLoad)
    }
  }, [pathname, hash])

  return null
}

export default ScrollToCorrectPageLocation
